import app from '../app';
import api from './api';
import utils from './utils';
import m from 'mithril';

const paymentSession = {
	initSession: (data) => {
		if (data.locale) {
			app.locale = data.locale;
		}

		app.paymentSession = {
			sessionId: data.sessionId,
			currency: data.currency,
			amount: parseFloat(data.amount),
			signature: data.signature,
			clientId: data.clientId,
			administrationId: data.administrationId,
			locationId: data.locationId,
			eventId: data.eventId,
			reference: data.reference ?? null,
			returnUrl: data.returnUrl ?? null,
			adyenStoreId: data.adyenStoreId ?? null,
			callbackUrl: data.callbackUrl ?? null,
		};
	},

	loadConfig: async () => {
		const body = utils.addParamsToBody({
			...app.paymentSession,
			locale: app.locale,
		});

		const result = await api.post('/configs', body);

		if (!result) {
			return;
		}

		if (result.session.open === false) {
			if (app.paymentSession.returnUrl) {
				window.location.href = app.paymentSession.returnUrl;
				return;
			}

			m.route.set('/closed');
		}

		app.adyen.paymentMethods = result.adyen?.paymentMethods ?? [];
		app.adyen.countryCodes = result.adyen?.countryCodes ?? {};

		return {
			open: result.session.open,
			status: result.session.status,
			hasPayment: result.session?.hasPayment ?? false,
		};
	},

	createPayment: async (paymentMethod, adyenBrowserInfo) => {
		const body = {
			psp: 'adyen',
			adyenPaymentMethod: paymentMethod,
			adyenBrowserInfo: adyenBrowserInfo,
			session: utils.addParamsToBody(app.paymentSession),
			domain: window.location.host,
		};

		const result = await api.post('/payments/sessions', body);

		if (!result) {
			return {
				success: false,
			};
		}

		return {
			success: true,
			data: result,
		};
	},

	cancelSession: async () => {
		const body = utils.addParamsToBody(app.paymentSession);

		const result = await api.post('/payments/sessions/cancel', body);

		if (app.paymentSession.returnUrl) {
			window.location.href = app.paymentSession.returnUrl;
			return;
		} else {
			m.route.set('/closed');
		}

		return result;
	},

	getSessionDetails: async (adyenData) => {
		const details = await api.post('/payments/sessions/details', {
			sessionId: app.paymentSession.sessionId,
			adyenData: adyenData,
		});

		if (!details) {
			return false;
		}

		return {
			success: true,
			data: details.adyen,
		};
	},

	showConfirmation: async () => {
		m.route.set(
			'/confirmation',
			utils.addParamsToBody({
				sessionId: app.paymentSession.sessionId,
				returnUrl: app.paymentSession.returnUrl,
			})
		);
	},

	getStatus: async () => {
		const response = await api.get(`/payments/${app.paymentSession.sessionId}/status`);
		if (response.success === false || response.status === 'open') {
			return {
				success: false,
			};
		}

		return {
			success: true,
			data: response,
		};
	},
};

export default paymentSession;
